import { Vue } from "vue-property-decorator";
import * as excel from "@/util/excel";
import { Field, DataItem, ExcelRow } from "./types/transactions_query";
import * as util from "../util";
import { ExcelUser } from "./types";
import store from "./store";

const lang = store.state.lang.data;

export async function exportUsersExcel(filteredUsers: ExcelUser[]): Promise<void> {
  const headers = getFieldDescriptors().map((fld) =>
    excel.header(fld.title, fld.field, fld.excel?.width || 15, fld.excel?.format)
  );
  const data = filteredUsers.map((user) => mapExcelRow(getFieldDescriptors(), user));
  return excel.writeSpreadsheet(lang.usersExportFilename, lang.users2, headers, data);
}

function mapExcelRow(fields: Field[], user: ExcelUser) {
  const result: ExcelRow = {};
  fields.forEach((field) => {
    if (field.field) {
      const value = excelFormat(user, field);
      if (value) {
        result[field.field] = value;
      }
    }
  });
  return result;
}

function excelFormat(item: ExcelUser, field: Field): number | string {
  if (field.excel && (field.excel.format === "number" || field.excel.format === "money")) {
    return util.toNumberSafe(util.objProperty(item, field.field));
  }
  return fieldFormat(item, field);
}

export function fieldCSS(item: DataItem, field: Field) {
  if (field.details && field.details.cssClass) {
    if (typeof field.details.cssClass === "string") {
      return util.objProperty(item, field.details.cssClass);
    }
    return field.details.cssClass(item);
  }
  return "";
}

export function fieldPriceColor(item: DataItem | number | string | undefined): string {
  let value = 0;
  if (typeof item == "string" || typeof item == "number") {
    value = Number(item);
  } else if (item?.amountWithSign) {
    value = Number(item.amountWithSign);
  }
  return value < 0 ? "red--text" : "";
}

export function fieldFormat(item: ExcelUser, field: Field): string {
  if (field.field) {
    const value = util.objProperty(item, field.field);
    if (field.format && typeof field.format !== "string") {
      return field.format(value);
    } else if (field.format) {
      if (field.field === "totalCost" && value) return Number(value).toFixed(4).replace(".", ",");
      return Vue.filter(field.format)(value);
    } else {
      return value;
    }
  } else if (field.format && typeof field.format !== "string") {
    return field.format(item);
  }
  return "";
}

export function getFieldDescriptors(): Field[] {
  return [
    // Only in Excel
    {
      title: lang.name,
      field: "displayName",
      excel: { order: 1, width: 25 }
    },
    {
      title: lang.email2,
      field: "email",
      excel: { order: 19, width: 34 }
    },
    {
      title: lang.permissions,
      field: "permissionScore",
      excel: { order: 30, width: 80 }
    },
    {
      title: lang.office,
      field: "branchIDs",
      excel: { order: 2, width: 40 }
    },
    {
      title: lang.lastAccess,
      field: "lastSignInTimeUTC",
      format: "utcToLocal",
      excel: { order: 3, width: 19 }
    }
  ];
}
